import { render } from "./NewsDetail.vue?vue&type=template&id=b60f7d6a&scoped=true&ts=true"
import script from "./NewsDetail.vue?vue&type=script&lang=ts"
export * from "./NewsDetail.vue?vue&type=script&lang=ts"

import "./NewsDetail.vue?vue&type=style&index=0&id=b60f7d6a&scoped=true&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b60f7d6a"]])

export default __exports__